//    __
//   / /____  ____ _____ ___
//  / __/ _ \/ __ `/ __ `__ \
// / /_/  __/ /_/ / / / / / /
// \__/\___/\__,_/_/ /_/ /_/

/* global */

import { scrollToHref } from '../util/scrolltohref.js';
import anime from 'animejs/lib/anime.es.js';

const setupTeam = () => {
  console.log('{ setupTeam }');

  // ----------------------------------------------------------------------------
  //
  // Team Grid / Slider
  //
  // ----------------------------------------------------------------------------
  const teamWrap = document.querySelector('.js-team');

  if (teamWrap) {
    // Reset splitting reveals - observer will have added .show
    $('.card--team__header .show').removeClass('show');

    const teamGrid = teamWrap.querySelector('.card-grid--team');
    const teamFooterContent = teamWrap.querySelector('.team-footer__content');
    const teamFooter = teamWrap.querySelector('.team-footer');
    const teamSlideRatio = 1.36;

    let teamFooterHTML;
    let teamGridH;
    let teamGridW;
    let teamFooterH;

    $(document)
      // ----------------------------------------------------------------------------
      //
      // Open Team Slider
      //
      // ----------------------------------------------------------------------------
      .on('click', '.card--team__link', function (e) {
        e.preventDefault();

        // console.groupCollapsed('{ Team }');
        // console.log('teamGridH: %o', teamGridH);
        // console.log('teamGridW: %o', teamGridW);
        // console.log('teamFooterH: %o', teamFooterH);
        // console.groupEnd();

        // store grid height & width before transition
        teamGridH = teamGrid.offsetHeight;
        teamGridW = Math.floor($(teamGrid).width());
        teamFooterH = $(teamFooterContent).height();

        // header-height = 72
        scrollToHref(teamWrap, -72)

          .then( () => {

            // store link clicked on
            const t = $(this);

            // get team member index
            const memberIndex = t.data('slide-index');
            // jump slider to correct index
            $('#slider-team').slick('slickGoTo', memberIndex, false);

            // reverse text reveal of clicked member
            t.find('.show').removeClass('show');

            // add active class to set state
            // hides grid, reveals slider
            $(teamWrap).addClass('active');
            $(teamWrap).find('.team-slider').addClass('show');

            // reverse splitting reveal on team footer
            $(teamWrap)
              .find('.team-footer__content .splitting')
              .removeClass('show');

            // capture team footer HTML after removing '.show' class
            teamFooterHTML = teamFooterContent.innerHTML;

            // console.log( 'teamFooterHTML: %o', teamFooterHTML );

            // ----------------------------------------------------------------------------
            // Team Grid resize
            // ----------------------------------------------------------------------------
            anime({
              targets: teamGrid,
              duration: 500,
              height: Math.floor(teamGridW / teamSlideRatio),
              delay: 0,
              easing: 'easeOutExpo',
              complete: function () {
                // populate team member bio info
                updateTeamFooter();
              }
            });

          } );

      })

      // ----------------------------------------------------------------------------
      //
      // Team - Slider Close
      //
      // ----------------------------------------------------------------------------
      .on('click', '.js-team-close', function () {
        // add active class to set state
        // hides slider, reveals grid
        $(teamWrap).removeClass('active');
        $(teamWrap).find('.team-slider').removeClass('show');

        // hide info
        $(teamFooter).find('.splitting').removeClass('show');

        // ----------------------------------------------------------------------------
        // Team Grid resize
        // ----------------------------------------------------------------------------
        anime({
          targets: teamGrid,
          duration: 500,
          height: teamGridH,
          delay: 0,
          easing: 'easeOutExpo',
          complete: function () {
            // revert team footer content
            teamFooterContent.innerHTML = teamFooterHTML;

            // ----------------------------------------------------------------------------
            // Team footer resize
            // ----------------------------------------------------------------------------
            anime({
              targets: teamFooterContent,
              duration: 500,
              height: teamFooterH,
              delay: 0,
              easing: 'easeOutExpo',
              complete: function () {
                // reveal info
                $(teamFooter).find('.splitting').addClass('show');
              }
            });
          }
        });
      });
  }
};

// ----------------------------------------------------------------------------
//
// Slide footer content updater
//
// ----------------------------------------------------------------------------
const updateTeamFooter = () => {
  // console.log( '{ updateTeamFooter }' );

  const teamWrap = document.querySelector('.js-team');
  const teamFooter = teamWrap.querySelector('.team-footer');
  const teamFooterContent = teamWrap.querySelector('.team-footer__content');
  const teamSlider = document.querySelector('#slider-team');
  // get current slide number
  const currentSlide = $(teamSlider).slick('slickCurrentSlide');
  const slide = $('.js-team [data-slick-index="' + currentSlide + '"]');
  const slideCopy = $(slide).find('.team__copy')[0];
  const slideCopyH = $(slideCopy).height();

  // update footer text with team member info
  teamFooterContent.innerHTML = slideCopy.innerHTML;

  // ----------------------------------------------------------------------------
  // Team footer resize
  // ----------------------------------------------------------------------------
  anime({
    targets: teamFooterContent,
    duration: 500,
    height: slideCopyH,
    delay: 50,
    easing: 'easeOutExpo',
    complete: function () {
      // reveal info
      $(teamFooter).find('.splitting').addClass('show');
    }
  });
};

export { setupTeam, updateTeamFooter };



// WEBPACK FOOTER //
// ./scripts/modules/team.js